import {
  FeatureType,
  type HSIcon,
  HSIconAutoPlay,
  type HSIconCommom,
  type HSIconSystem,
  HSIconType,
  HSPosType,
} from '@types';
import { HOTSPOT_SYS_ICONS } from '../constants';
import { hsRecentSettings } from '../hsRecentSettings';

interface Params {
  type: HSIconType;
  ath?: number;
  atv?: number;
  featType?: FeatureType;
}

const commonDefault: HSIconCommom = {
  scaleLock: 1,
  scaleX: 1,
  scaleY: 1,
  stick: 0,
  positionType: HSPosType.normal,
  rx: 0,
  ry: 0,
  rz: 0,
};

function hotspotIconDefault({
  type,
  ath = 0,
  atv = 0,
  featType = FeatureType.scene,
}: Params): HSIcon {
  const defaultData: HSIconSystem = {
    type: HSIconType.system,
    ath,
    atv,
    scaleX: 0.5,
    scaleY: 0.5,
    edge: 'center',
    stick: 0,
    url: HOTSPOT_SYS_ICONS[featType].url,
    frame: HOTSPOT_SYS_ICONS[featType].frame,
  };
  switch (type) {
    case HSIconType.system:
      return defaultData;
    case HSIconType.mark:
      return {
        type: HSIconType.mark,
        ath,
        atv,
        edge: 'bottom',
        length: 30,
        stick: 0,
        lineType: 0,
        lineWidth: 1,
        lineColor: '255,255,255,1',
        media: {
          enabled: 0,
        },
      };
    case HSIconType.image:
      return {
        type: HSIconType.image,
        ath,
        atv,
        edge: 'center',
        media: [],
        autoPlayType: HSIconAutoPlay.auto,
        autoPlayDuration: 3,
        ...commonDefault,
      };
    case HSIconType.seqFrame:
      return {
        type: HSIconType.seqFrame,
        ath,
        atv,
        edge: 'center',
        media: [],
        ...commonDefault,
      };
    case HSIconType.video:
      return {
        type: HSIconType.video,
        ath,
        atv,
        edge: 'center',
        media: [],
        autoPlay: 1,
        loop: 1,
        mute: 0,
        turnOffBgMusicOnPlay: 0,
        turnOffBgVoiceOnPlay: 0,
        ...commonDefault,
        stick: 1,
      };
    case HSIconType.polygon:
      return {
        type: HSIconType.polygon,
        ath,
        atv,
        points: [],
        fillColor: '255,255,255,0.5',
        borderWidth: 2,
        borderColor: '40,110,250,1',
        overFillColor: '255,255,255,0.5',
        overBorderWidth: 2,
        overBorderColor: '40,110,250,1',
        blink: 1,
        ...hsRecentSettings.iconPolygon, // 使用最近一次的设置
      };
    default:
      return defaultData;
  }
}

export default hotspotIconDefault;
